import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';

import {
    FETCH_LATEST_LACTATE_THRESHOLD,
    FETCH_LATEST_LACTATE_THRESHOLD_START,
    FETCH_LATEST_LACTATE_THRESHOLD_SUCCESS,
    FETCH_LATEST_LACTATE_THRESHOLD_FAIL,
    FETCH_RANGE_LACTATE_THRESHOLD_HR,
    FETCH_RANGE_LACTATE_THRESHOLD_HR_START,
    FETCH_RANGE_LACTATE_THRESHOLD_HR_SUCCESS,
    FETCH_RANGE_LACTATE_THRESHOLD_HR_FAIL,
    FETCH_RANGE_LACTATE_THRESHOLD_SPEED,
    FETCH_RANGE_LACTATE_THRESHOLD_SPEED_START,
    FETCH_RANGE_LACTATE_THRESHOLD_SPEED_SUCCESS,
    FETCH_RANGE_LACTATE_THRESHOLD_SPEED_FAIL
} from 'actions/ActionTypes';

export function* fetchLatestLactateThresholdData() {
    try {
        yield put({
            type: FETCH_LATEST_LACTATE_THRESHOLD_START
        });

        const response = yield call(gcApi.get, '/biometric-service/biometric/latestLactateThreshold');

        yield put({
            type: FETCH_LATEST_LACTATE_THRESHOLD_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_LATEST_LACTATE_THRESHOLD_FAIL,
            data: {}
        });
    }
}

/**
 * aggregation: daily, weekly, monthly, yearly, lifetime
 * aggregationStrategy: LATEST, AVERAGE
 * sport: RUNNING etc...
 */
export function* fetchRangeLactateThresholdHRData(action) {
    try {
        const {
            payload: { startDate, endDate, aggregation, aggregationStrategy, sport }
        } = action;

        yield put({
            type: FETCH_RANGE_LACTATE_THRESHOLD_HR_START
        });

        const response = yield call(
            gcApi.get,
            `/biometric-service/stats/lactateThresholdHeartRate/range/${startDate}/${endDate}`,
            {
                params: {
                    aggregation,
                    aggregationStrategy,
                    sport
                }
            }
        );

        yield put({
            type: FETCH_RANGE_LACTATE_THRESHOLD_HR_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_RANGE_LACTATE_THRESHOLD_HR_FAIL,
            data: {}
        });
    }
}

/**
 * aggregation: daily, weekly, monthly, yearly, lifetime
 * aggregationStrategy: LATEST, AVERAGE
 * sport: RUNNING etc...
 */
export function* fetchRangeLactateThresholdSpeedData(action) {
    try {
        const {
            payload: { startDate, endDate, aggregation, aggregationStrategy, sport }
        } = action;

        yield put({
            type: FETCH_RANGE_LACTATE_THRESHOLD_SPEED_START
        });

        const response = yield call(
            gcApi.get,
            `/biometric-service/stats/lactateThresholdSpeed/range/${startDate}/${endDate}`,
            {
                params: {
                    aggregation,
                    aggregationStrategy,
                    sport
                }
            }
        );

        yield put({
            type: FETCH_RANGE_LACTATE_THRESHOLD_SPEED_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_RANGE_LACTATE_THRESHOLD_SPEED_FAIL,
            data: {}
        });
    }
}

export const lactateThresholdSagas = [
    takeEvery(FETCH_LATEST_LACTATE_THRESHOLD, fetchLatestLactateThresholdData),
    takeEvery(FETCH_RANGE_LACTATE_THRESHOLD_HR, fetchRangeLactateThresholdHRData),
    takeEvery(FETCH_RANGE_LACTATE_THRESHOLD_SPEED, fetchRangeLactateThresholdSpeedData)
];
